import { cn } from "@/lib/utils";
import { Skeleton } from "@/shared/components/ui/skeleton";
interface MetricCardProps {
  title: string;
  value: string | number;
  icon: React.ReactNode;
  className?: string;
  isLoading?: boolean;
}

export default function MetricCard({
  title,
  value,
  icon,
  className,
  isLoading = false,
}: MetricCardProps) {
  return (
    <div
      className={cn(
        "flex flex-col w-full justify-between px-[20px]",
        className
      )}
    >
      <div className="flex gap-[6px] items-start justify-between relative w-full">
        <div className="flex items-center justify-center">
          <p className="text-[14px] font-[600] text-[#18181b] leading-[20px]">
            {title}
          </p>
        </div>
        <div
          className={` bg-white border border-[#e4e4e7] flex items-center justify-center rounded-full shadow-[0px_1px_2px_0px_rgba(10,13,20,0.03)] size-[40px]`}
        >
          <div className="relative size-[16px]">{icon}</div>
        </div>
      </div>
      <div className="flex">
        <div className="flex items-center">
          {
            isLoading ? 
              <Skeleton className="w-[40px] h-[24px] mt-[4px] text-[24px] font-[Inter] font-[700] text-[#09090b]" /> 
              : 
              <p className="text-[24px] font-[Inter] font-[700] text-[#09090b] leading-[32px]">
                { value || 0}
              </p>
          }
        </div>
      </div>
    </div>
  );
}
